import { createSlice } from '@reduxjs/toolkit'

const getDefaultSelectionRange = () => ({
  startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  endDate: new Date().toISOString(),
  key: 'selection',
})

const initialState = {
  sourcesActiveIds: [],
  mosquitoTypeInactiveTypeIds: [],
  smartTrapFilterIds: ['active', 'inactive', 'passive'],
  mosquitoSexActiveIds: ['female', 'undefined'],
  selectionRange: getDefaultSelectionRange(),
  hoveredItem: null,
  hoveredClusterTrapIds: [],
  clickedItem: null,
}

const mosquitoTraps = createSlice({
  name: 'mosquitoDetection',
  initialState,
  reducers: {
    setSelectionRange: (state, action) => {
      const defaults = getDefaultSelectionRange()
      const nextSelectionRange = action.payload || {}

      state.selectionRange = {
        ...defaults,
        ...state.selectionRange,
        ...nextSelectionRange,
      }
    },
    setSourcesActiveIds: (state, action) => {
      state.sourcesActiveIds = action.payload
    },
    setMosquitoTypeInactiveTypeIds: (state, action) => {
      state.mosquitoTypeInactiveTypeIds = action.payload
    },
    setMosquitoSexActiveIds: (state, action) => {
      state.mosquitoSexActiveIds = action.payload
    },
    setHoveredItem: (state, action) => {
      state.hoveredItem = action.payload
    },
    setHoveredClusterTrapIds: (state, action) => {
      state.hoveredClusterTrapIds = action.payload
    },
    setClickedItem: (state, action) => {
      state.clickedItem = action.payload
    },
    toggleSmartTrapFilterId: (state, action) => {
      if (state.smartTrapFilterIds.includes(action.payload)) {
        state.smartTrapFilterIds = state.smartTrapFilterIds.filter(id => id !== action.payload)
      } else {
        state.smartTrapFilterIds = [...state.smartTrapFilterIds, action.payload]
      }
    },
  },
})

export const {
  setActiveTab,
  setActiveSubTab,
  setSourcesActiveIds,
  setMosquitoSexActiveIds,
  setMosquitoTypes,
  setMosquitoTypeInactiveTypeIds,
  setMosquitoSpecimens,
  setMosquitoGeoSpecimens,
  setSelectionRange,
  setHoveredItem,
  setHoveredClusterTrapIds,
  setClickedItem,
  toggleSmartTrapFilterId,
} = mosquitoTraps.actions

export default mosquitoTraps.reducer
